import { confirmPromptConstants } from '../_constants';

export function confirmPrompt(state = {}, action) {
    switch (action.type) {
        case confirmPromptConstants.SHOW:
            return {
                title: action.title,
                description: action.description,
                actionText: action.actionText,
                show: true
            };
        case confirmPromptConstants.HIDE:
            return {
                show: false
            };
        default:
            return state
    }
}